// extracted by mini-css-extract-plugin
export default {"button":"TwoButtonsInput_button__u2Lln","input":"TwoButtonsInput_input__wCqa1"};